import React, { FC, useContext } from 'react';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { InviteUserModal } from '../InviteUserModal/InviteUserModal';
import { OrganizationContext } from '../../contexts/OrganizationContext';
import { useDialog } from '../../hooks/useDialog';
import { useTranslation } from 'react-i18next';
import { OrganizationInvitesFetcher } from '../../fetchers/OrganizationInvitesFetcher';
import { apiOrganization } from '../../resources/api/apiOrganization';

const { useInviteUsers } = apiOrganization;

interface IProps {
  onDone?: () => Promise<any>;
}

export const InviteButton: FC<IProps> = ({ onDone }) => {
  const { organization } = useContext(OrganizationContext);
  const { onRefresh: defaultOnRefresh } = useContext(OrganizationInvitesFetcher.Context);
  const { Guard: GuardInviteUsers } = useInviteUsers(organization?.name);

  const { isOpen: isInvite, openUrl: inviteUrl, close: closeInvite } = useDialog('invite');
  const { t } = useTranslation();

  if (!organization) return null;

  return (
    <GuardInviteUsers>
      <Button component={Link} to={inviteUrl} variant="contained" color="primary">
        {t('organization.users.addButton')}
      </Button>

      <InviteUserModal
        open={isInvite}
        closeDialog={closeInvite}
        organization={organization}
        onDone={onDone ?? defaultOnRefresh}
      />
    </GuardInviteUsers>
  );
};
